import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function DiagnostiicVariable({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);
  return (
    <FullBodyContentView
      title="View Diagnostic Variables"
      fullCaption="Drive Gain.............3%...................... 
      Velocity.................//fastlF*/...............
      Live Zero..............0.0f gram/s...........
      Field Verification....//fastlF*/..............
      Tube Frequency....0.0f.....................
      Delta T...................0.0f.....................
      "
    />
  );
}

export default DiagnostiicVariable;
